<template>
  <div>
    <div>
      <!--      <h5>Jiggu</h5>-->
      <b-table :sticky-header="true" style="max-height:1000px" :items="profitData">
<!--        <template #cell(profit)="data">-->
<!--          <span>{{ data.item.profit }}</span>-->
<!--        </template>-->
      </b-table>
      Total sum: {{ parseFloat(profitAggr).toFixed(2) }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      profitData: [],
      documents: {
        rates: "",
        awbs: "",
      },
    };
  },
  computed: {
    profitAggr() {
      return this.profitData.reduce((acc, cur) => {
        acc.profit += parseFloat(cur.profit.toFixed(2));
        return acc;
      }, { profit: 0 }).profit.toFixed(2);
    },
  },
  methods: {
    async submit() {

      const data = await this.$post("/profits-data", this.profitData);
      this.$warn(data.msg);
      this.init();
    },
    async init() {
      // we are getting this data:
      this.loading = true;
      const data = await this.$getRO("/profits-data", {
        params: this.$route.query,
      });
      this.profitData = data.map(item => ({
        ...item,
        profit: parseFloat(item.profit.toFixed(2)),
        price: parseFloat(item.price.toFixed(2)),
        charge: parseFloat(item.charge.toFixed(2)),
        fxRate: parseFloat(item.fxRate.toFixed(2)),
        rate: parseFloat(item.rate.toFixed(2)),
        subTotal: parseFloat(item.subTotal.toFixed(2)),
        declarePrice: parseFloat(item.declarePrice.toFixed(2)),
        costTotal: parseFloat(item.costTotal.toFixed(2)),
        logisWeight: parseFloat(item.logisWeight.toFixed(2)),
        proratedShipFee: parseFloat(item.proratedShipFee.toFixed(2)),
        proratedShipCost: parseFloat(item.proratedShipCost.toFixed(2)),
      }));

      this.loading = false;
    },
  },
  beforeRouteLeave(to, from, next) {
    // this.ws.close();
    next();
  },
  watch: {
    history(history) {
      localStorage.setItem("history", JSON.stringify(history));
    },
  },
  async created() {
    this.init();
  },
  mounted() {},
};
</script>
<style scoped>
.b-card {
  font-family: Courier serif;
}
</style>
